import { defineMessages } from 'react-intl';

export default defineMessages({
    activities: {
        id: 'app.html.index.Activities',
        defaultMessage: 'Activities',
    },
    accounts: {
        id: 'app.html.index.Accounts',
        defaultMessage: 'Accounts',
    },
    policies: {
        id: 'app.html.index.Policies',
        defaultMessage: 'Policies',
    },
    claims: {
        id: 'app.html.index.Claims',
        defaultMessage: 'Claims',
    },
    commission: {
        id: 'app.html.index.Commission',
        defaultMessage: 'Commission',
    },
    directBill: {
        id: 'app.html.index.Direct Bills',
        defaultMessage: 'Direct Bills',
    },
    brokerBill: {
        id: 'app.html.index.Broker Bill',
        defaultMessage: 'Broker Bill',
    }
});
